"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalMenu = ModalMenu;
var _react = _interopRequireWildcard(require("react"));
var _Drawer = require("b2b-components/theme/components/Drawer");
var _classnames = _interopRequireDefault(require("classnames"));
var _Menu = require("./Menu");
var _RecursiveMenu = require("./RecursiveMenu");
require("./ModalMenu.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ModalMenu(_ref) {
  let {
    activeLanguage,
    brands,
    catalog,
    ownAssortment,
    className,
    isLoggedIn,
    languages,
    links,
    catalogLinks,
    onLanguageChange,
    onLogout,
    onModalLinkClick,
    text,
    companyName
  } = _ref;
  const [categoryPath, setCategoryPath] = (0, _react.useState)([]);
  const onOpenDrawer = () => {
    setCategoryPath([]);
  };
  const openNextLevel = (previousTitle, children, href, title, id) => e => {
    e.preventDefault();
    setCategoryPath([...categoryPath, {
      previousTitle,
      children,
      href,
      title,
      id
    }]);
  };
  const openPrevLevel = e => {
    e.preventDefault();
    setCategoryPath(categoryPath.slice(0, -1));
  };
  const handleLinkClick = closeModal => url => e => {
    e.preventDefault();
    onModalLinkClick(url);
    closeModal(e);
  };
  const renderContent = closeModal => {
    if (categoryPath.length > 0) {
      const lastCategory = categoryPath.at(-1);
      return /*#__PURE__*/_react.default.createElement(_RecursiveMenu.RecursiveMenu, {
        previousTitle: lastCategory.previousTitle,
        catalogLinks: lastCategory.id === _RecursiveMenu.MENU_CATEGORY_ID.catalog && catalogLinks,
        ownAssortment: lastCategory.id === _RecursiveMenu.MENU_CATEGORY_ID.catalog && ownAssortment,
        href: lastCategory.href,
        title: lastCategory.title,
        openNextLevel: openNextLevel,
        openPrevLevel: openPrevLevel,
        onLinkClick: handleLinkClick(closeModal),
        text: text,
        companyName: companyName
      }, lastCategory.children);
    }
    return /*#__PURE__*/_react.default.createElement(_Menu.Menu, {
      activeLanguage: activeLanguage,
      catalog: catalog,
      brands: brands,
      isLoggedIn: isLoggedIn,
      languages: languages,
      links: links,
      onLanguageChange: onLanguageChange,
      onLinkClick: handleLinkClick(closeModal),
      onLogout: onLogout,
      onModalClose: closeModal,
      openNextLevel: openNextLevel,
      text: {
        catalog: text.catalog,
        brands: text.brands,
        home: text.home,
        logout: text.logout
      }
    });
  };
  const rootClassName = (0, _classnames.default)('cds-Header-ModalMenuModal', className);
  return /*#__PURE__*/_react.default.createElement(_Drawer.Drawer, {
    className: rootClassName,
    onOpenDrawer: onOpenDrawer,
    content: renderContent
  });
}
//# sourceMappingURL=ModalMenu.js.map